import { BKNoticeBoardPage } from "app/pages/noticeboard";
import { ReactNode } from "react";
import { NotFoundPage } from "sketon/ui/404";
import { BSDetailPage } from "../../app/pages/details";
import { BSMainPage } from "../../app/pages/main";
import { BSYearPage } from "../../app/pages/main/yearBy";

export interface RouterInfo {
  name: string;
  path: string;
  nav: string;
  element: ReactNode | null;
}

export const ROUTER_MAP: RouterInfo[] = [
  { name: BSMainPage.name, path: "/", element: <BSMainPage />, nav: "/" },
  {
    name: BSYearPage.name,
    path: "/books/:year",
    element: <BSYearPage />,
    nav: "/books",
  },
  {
    name: BSDetailPage.name,
    path: "/book/:isbn",
    element: <BSDetailPage />,
    nav: "/book",
  },
  {
    name: BKNoticeBoardPage.name,
    path: "/board",
    element: <BKNoticeBoardPage />,
    nav: "/board",
  },
  {
    name: NotFoundPage.name,
    path: "/404",
    element: <NotFoundPage />,
    nav: "/404",
  },
  {
    name: NotFoundPage.name,
    path: "*",
    element: <NotFoundPage />,
    nav: "/404",
  },
];

export function getNavPath(name: string): string {
  var path = "/";
  var ret = ROUTER_MAP.find((item) => {
    return item.name === name;
  });

  if (ret !== undefined) {
    path = ret.nav;
  }

  return path;
}
